/**
 * main jquery code used as plugin
 * the jquery framework is linked externally from their cdn in the app.php
 * @filesource  ./app/js/app.js
 * @license     CC BY-SA 4.0 (https://creativecommons.org/licenses/by-sa/4.0/)
 * @author      Rej <rej>
 * @return      something amazing
 * @link        https://jquery.com/
 */
$(function() {

    // subnav hidden on mobile scroll
    // @return tpl -> nav.php
    var UIHeader = $("header");
    var UIContent = $("article.fst, article.fst-home");
    var UIScroll = "280";

    $(window).scroll(function(e) {

        if ($(this).scrollTop() > UIScroll) {
            UIHeader.addClass("fheader animate slideInDown");
            // Helper providing site jump
            UIContent.addClass("asmooth");

        } else {
            UIHeader.removeClass("fheader animate slideInDown");
            UIContent.removeClass("asmooth");

        }

    });

    var UIMobileNavMore = false;

    $("a.btmobilenavmore").click(function(n) {
        n.preventDefault();
        $("div.nav-mdummy").removeClass("nav-mdummy-show animated slideInLeft");
        if (UIMobileNavMore == false) {
            $("div.headernav").addClass("show-mobile-more animated slideInRight");
            $("body").addClass("noscroll");
            UIMobileNavMore = true;
        } else {
            $("div.headernav").removeClass("show-mobile-more animated slideInRight");
            $("body").removeClass("noscroll");
            UIMobileNavMore = false;
        }
    });

    var UIMobileHNav = false;

    $("a.btmobilenav").click(function(n) {
        n.preventDefault();
        $("div.headernav").removeClass("show-mobile-more animated slideInRight");
        if (UIMobileHNav == false) {
            $("div.nav-mdummy").addClass("nav-mdummy-show animated slideInLeft");
            $("body").addClass("noscroll");
            UIMobileHNav = true;
        } else {
            $("div.nav-mdummy").removeClass("nav-mdummy-show animated slideInLeft");
            $("body").removeClass("noscroll");
            UIMobileHNav = false;
        }
    });


    // animate scroll to site top
    // @return sites -> app.php
    $("a.lnk-suche").click(function(s) {
        s.preventDefault();
        $("form#search").submit();

    });

    // animate scroll to site top
    // @return sites -> app.php
    $("a#ptop").click(function(e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $("#pagetop").offset().top
        }, 400);
    });

    //icon mouseover
    $("a.iku").on("mouseover", function(){
        $("a.iku img").attr("src" , "/typo3conf/ext/ewprovider/Resources/Public/img/icon-kununu-omo.svg");
    }).on("mouseout", function(){
        $("a.iku img").attr("src" , "/typo3conf/ext/ewprovider/Resources/Public/img/icon-kununu.svg");
    });

    // Nav popover mouseover
    $("nav ul li").on("mouseover", function(n){
        n.preventDefault();
        var UINavLink = $(this).attr("id");

        $("nav ul li").removeClass("hover");
        $("div.nav-popover div").addClass("inaktiv");

        if ($("div.nav-popover").hasClass("nav-popover-inaktiv")){
            $("div.nav-popover").removeClass("nav-popover-inaktiv");
            $("div.nav-popover div." + UINavLink).removeClass("inaktiv");
        }

    });

    // Nav popover mouseover
    $("nav ul li").on("mouseout", function(n){
        n.preventDefault();
        var UINavLink = $(this).attr("id");
        $("div.nav-popover").addClass("nav-popover-inaktiv");
    });


    // Nav popover mouseover
    $("div.nav-popover div").on("mouseover", function(n){
        n.preventDefault();
        var UINavLink = $(this).attr("class");
        $("nav ul li#" + UINavLink).addClass("hover");
    });


    // Nav popover mouseover
    $("div.nav-popover div ul li").on("mouseover", function(n){
        n.preventDefault();
        var UINavL2Link = $(this).attr("class");

        // wer nicht inaktiv ist, bekommt die klasse
        if ($("div.nav-popover div ul li ul").not("inaktiv")){
            $("div.nav-popover div ul li ul").addClass("inaktiv");
        }

        // togglen der sichtbarkeit
        if ( $("div.nav-popover div ul li ul#"+UINavL2Link).hasClass("inaktiv") ){
            $("div.nav-popover div ul li ul#"+UINavL2Link).removeClass("inaktiv");
        }

    });

    // Nav popover level 2 mouseover
    // Nav popover level 2 inaktiv setzen
    $("div.nav-popover div ul li").on("mouseout", function(){
        // wer nicht inaktiv ist, bekommt die klasse
        $("div.nav-popover div ul li ul").addClass("inaktiv");
    });

    // alle inaktiv setzen
    $("header, article").on("mouseover", function(){
        $("div.nav-popover").addClass("nav-popover-inaktiv");
        $("div.nav-popover div").addClass("inaktiv");
        $("div.nav-popover div ul li ul").addClass("inaktiv");
        $("nav ul li").removeClass("hover");
    });


    // faq view toogle
    // @return sites -> faq.php
    $("div.faq a").on("click", function(f){
        f.preventDefault();
        var UIQuestion = $(this).attr("class");
        // alle faq zuklappen + link down
        $("div.faq div.ant").addClass("ant-hidden");
        $("div.faq div.fr a i").attr("class", "icons ion-md-arrow-dropdown");

        $(this).children().attr("class", "icons ion-md-arrow-dropup");
        $("div.faq div#" + UIQuestion).removeClass("ant-hidden");

    });

    /*// nomenclatur view toogle
    // @return sites -> tylose-mhec.php
    $(document).on("click", "table.nomenclatur thead tr th a", function(n) {
        n.preventDefault();
        var UITBody = $("table.nomenclatur tbody");
        // alle faq zuklappen + link down
        if ( (UITBody).hasClass("show") ){
            UITBody.removeClass("show");
            $("table.nomenclatur thead tr th.t-toggle a").html("<i class=\"icon ion-md-funnel\"></i>&nbsp;Show");
            // $("table.nomenclatur thead tr th a").attr("class", "icons ion-md-arrow-dropdown");
        } else {
            $("table.nomenclatur thead tr th.t-toggle a").html("<i class=\"icon ion-md-funnel\"></i>&nbsp;Hide");
            UITBody.addClass("show");
        }

    });*/

    // CTA popover toggle while scrolling
    // @return sites -> footer.php

    $("footer div ul li ul").addClass("hide");

    $(window).bind('scroll', function() {
        setTimeout(function() {

            $("div.cta-mail, div.cta-tel, div.cta-ap").css("display", "none");
            // subnavi ausblenden
            $("div.nav-popover").addClass("nav-popover-inaktiv");
            $("div.nav-popover div").addClass("inaktiv");
            $("div.nav-popover div ul li ul").addClass("inaktiv");
            $("nav ul li").removeClass("hover");
        }, 400);

    });


    // Sitelink UI behaviour toogle view while scrolling
    // open at end of site vs. close while scoll reverse
    // @return sites -> footer.php
    var UILastScrollPos = 0;
    $(window).scroll(function(event) {
        var UIScrollPos = $(this).scrollTop();
        if (UIScrollPos > UILastScrollPos) {
            // downscroll code
            var UISiteEnde = $(document).height() - $(window).height();
            // FF fix +10px fÃ¼r scrollTop()
            if (UISiteEnde <= ($(window).scrollTop() + 10)) {
                // if (UISiteEnde <= $(window).scrollTop()) {
                $("footer div ul li ul").removeClass("hide");
            }

        } else {
            // upscroll code
            var UISiteEnde = $(document).height() - $(window).height();

            if ($(window).scrollTop() <= UISiteEnde - 250) {
                $("footer div ul li ul").addClass("hide");
            }
        }
        UILastScrollPos = UIScrollPos;
    });


    $("div.grid").masonry({
        // options
        itemSelector: '.item',
        fitWidth: false,
        transitionDuration: 0,
        percentPosition: true
    });


});